import { render } from "./AllLabBookings.vue?vue&type=template&id=4ab0ee0a&scoped=true"
import script from "./AllLabBookings.vue?vue&type=script&lang=js"
export * from "./AllLabBookings.vue?vue&type=script&lang=js"

import "./AllLabBookings.vue?vue&type=style&index=0&id=4ab0ee0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab0ee0a"]])

export default __exports__